import { render, staticRenderFns } from "./CredentialCopyField.vue?vue&type=template&id=37f251dc&scoped=true"
import script from "./CredentialCopyField.vue?vue&type=script&lang=js"
export * from "./CredentialCopyField.vue?vue&type=script&lang=js"
import style0 from "./CredentialCopyField.vue?vue&type=style&index=0&id=37f251dc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f251dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37f251dc')) {
      api.createRecord('37f251dc', component.options)
    } else {
      api.reload('37f251dc', component.options)
    }
    module.hot.accept("./CredentialCopyField.vue?vue&type=template&id=37f251dc&scoped=true", function () {
      api.rerender('37f251dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/External/Shoplazza/components/CredentialCopyField.vue"
export default component.exports